import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';

import moment from 'moment';

import Page from 'xpi-black-ui/Base/Page';
import { Row } from 'xpi-black-ui/Base/Grid';
import Wrapper from 'xpi-black-ui/Base/Wrapper'
import Loading from 'xpi-black-ui/Base/Loading';
import { H1 } from 'xpi-black-ui/Base/Typography';
import Navigation from 'xpi-black-ui/Common/Navigation';

import TimeLineSidebar from './compose/Sidebar';
import CreateQuote from './compose/CreateQuote';
import StoredQuotes from './compose/StoredQuotes';

import Sidebar from 'components/Common/Sidebar';
import PageView from 'components/Common/PageView';
import BlackContainer from 'components/Common/BlackContainer';

import waConfig from 'utils/waConfig';
import { LoadConfiguration, LoadQuotes } from '../../redux-flow/actions/custom-quotes';

import { Container } from './styles';

function CustomQuotes({ location }) {
  moment.lang('pt-br');

  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname } = location;

  const [loadingPage, setLoadingPage] = useState(false);

  const {
    msg,
    quotes,
    assets,
    quoteEdit,
    strategies,
    loadingQuotes,
    loadingConfiguration,
  } = useSelector(({ CustomQuotes }) => CustomQuotes);

  useEffect(() => {
    if (strategies?.length === 0) {
      dispatch(LoadConfiguration());
      dispatch(LoadQuotes());
    }
  }, []);

  useEffect(() => {
    if (quoteEdit) {
      history.push('/cotacoes-personalizadas/nova');
    }
  }, [quoteEdit]);

  useEffect(() => {
    setLoadingPage((loadingQuotes === true && loadingConfiguration === true) || loadingQuotes || loadingConfiguration);
  }, [loadingQuotes, loadingConfiguration]);

  const navigationItems = [
    {
      title: 'Nova cotação',
      link: '/cotacoes-personalizadas/nova',
      component: () => (
        <CreateQuote
          msg={msg}
          assets={assets}
          quoteEdit={quoteEdit}
          strategies={strategies}
        />
      )
    },
    {
      title: `Cotações armazenadas (${quotes?.length})`,
      link: '/cotacoes-personalizadas/armazenadas',
      component: () => (
        <StoredQuotes quotes={quotes} msg={msg} />
      )
    }
  ];

  return (
    <BlackContainer>
      <PageView page={waConfig.pageview.customQuotes} />
      <Container>
        <Page>
          <Row align="normal" style={{ width: '100%' }}>
            <Sidebar style={{ height: 'fit-content' }}>
              <TimeLineSidebar />
            </Sidebar>

            <Wrapper spaceTop innerWrapper>
              <H1>Cotações Personalizadas</H1>

              <Row border justifyContent="space-between" style={{ marginBottom: '32px' }}>
                <Navigation navigationItems={navigationItems} locationPathName={pathname} />
              </Row>

              <Switch>
                {navigationItems.map(route => (
                  <Route
                    key={route.link}
                    name={route.title}
                    path={route.link}
                    component={route.component}
                  />
                ))}
                <Redirect exact from="/cotacoes-personalizadas" to={navigationItems[0].link} />
              </Switch>
            </Wrapper>
          </Row>

          {loadingPage && <Loading text="Carregando..." fixed />}
        </Page>
      </Container>
    </BlackContainer>
  );
}

export default CustomQuotes;
